import type IProduct from "@api/models/IProduct";
import SSAccountCard from "@core-components/accountCard/SSAccountCard";
import SSBoughtFooterCard from "@core-components/accountCard/components/SSBoughtFooterCard";
import SSHeaderCard from "@core-components/accountCard/components/SSHeaderCard";
import SSProductDetailLines from "@core-components/product/component/SSProductDetailLines";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Stack, Text } from "@mantine/core";
import getAvailableAccountIds from "@modules/order/hooks/getAvailableAccountIds.hook";
import { useLoLProductAsBasketAccount } from "@modules/order/hooks/useBasketItem.hook";

interface IProductCardProps {
  product: IProduct;
  header: string;
}

const SSProductCard: React.FC<IProductCardProps> = ({ product, header }) => {
  const { t } = useAppTranslation();
  const { getFirstAvailableId, isOutOfStock } = getAvailableAccountIds(
    product.accounts,
  );

  const { regionAndLanguageUrlBuilder, currentRegion } = useAppRegion();

  return (
    <SSAccountCard
      href={regionAndLanguageUrlBuilder(product.categorySlug, product.slug)}
      header={
        <SSHeaderCard
          backgroundUrl={product.thumbnail}
          alt={t("skinAlt", {
            name: t(`${product.i18nKey}.name`, {
              region: currentRegion.toUpperCase(),
            }),
          })}
          isOutOfStock={isOutOfStock}
          variant="product"
        >
          <Stack gap={0}>
            <Text className="text-left font-bold font-secret text-lg text-primary-dark-text">
              {t(`${product.i18nKey}.name`, {
                region: currentRegion.toUpperCase(),
              })}
            </Text>
            <SSWhiteText className="break-words font-secret-black text-[22px] leading-snug">
              {header}
            </SSWhiteText>
          </Stack>
        </SSHeaderCard>
      }
    >
      <SSProductDetailLines
        blueEssence={product.blueEssence}
        region={currentRegion}
        i18nKey={product.i18nKey}
        status={product.status}
      />
      <SSBoughtFooterCard
        account={useLoLProductAsBasketAccount(
          product,
          getFirstAvailableId(),
          currentRegion,
        )}
        isOutOfStock={isOutOfStock}
      />
    </SSAccountCard>
  );
};

export default SSProductCard;
